import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes, type SelectHTMLAttributes } from 'react'
import { cn } from '../lib/cn'

const BASE =
  'w-full rounded-md border border-line bg-white px-3 py-2 text-sm text-ink placeholder:text-slatey/70 ' +
  'focus:outline-none focus:border-forest focus:ring-2 focus:ring-forest/20 ' +
  'disabled:opacity-60 disabled:bg-ivory'

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return <input ref={ref} className={cn(BASE, className)} {...rest} />
  },
)

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function Textarea({ className, ...rest }, ref) {
    return <textarea ref={ref} className={cn(BASE, 'min-h-[100px]', className)} {...rest} />
  },
)

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, children, ...rest }, ref) {
    return (
      <select ref={ref} className={cn(BASE, 'pr-8 appearance-none cursor-pointer', className)} {...rest}>
        {children}
      </select>
    )
  },
)
